<template>
    <!-- 文章修改页 -->
    <div class="pdf">
        <!-- 标题 -->
        <div>
            <p class="p-padd">标题</p>
            <el-input
                v-model="title"
                placeholder="请输入内容"
                class="input-width"
            ></el-input>
        </div>
        <br />
        <!-- 正文 -->
        <div class="editor-container">
            <!-- ===================  editor组件 start  ==================== -->
            <p class="p-padd"><b>正&nbsp;&nbsp;&nbsp;&nbsp;文</b></p>
            <!-- <vue-ueditor-wrap :config="myConfig" v-model="defaultMsg" v-if="ueState"></vue-ueditor-wrap> -->
            <vue-ueditor-wrap
                v-model="defaultMsg"
                :config="myConfig"
                @ready="ready"
            ></vue-ueditor-wrap>
            <!-- ===================  editor组件 end    ==================== -->
        </div>
        <br />
        <!-- 发布时间 -->
        <div class="block">
            <p class="p-padd"><b>发布日期</b></p>
            <el-date-picker
                v-model="datePicker"
                type="datetime"
                placeholder="选择日期时间">
            </el-date-picker>
        </div>
        <br />
        <div style="padding-top:30px">
            <el-button @click="goBack()">返&nbsp;&nbsp;回</el-button>
            <el-button type="primary" @click="execUpdateArticle()"
                >提&nbsp;&nbsp;交</el-button
            >
        </div>
    </div>
</template>


<script>
import webNoticeUpdate from "@/assets/js/manager/webNoticeUpdate.js";
export default {
    ...webNoticeUpdate
};

</script>




<style lang="scss" scoped>
.pdf .div{
    width:100%
}
.div-height{
    height: 55px;
}
.padding-top{
    padding-top: 20px;
}
.input-div{
    width: 80%;
}
.right{
    float: right;
    width: 40%;
    text-align: -webkit-right;
}
.el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
    width: 98%;
}
.left{
    float:left;
}
.dialog-span{
    font-size: 20px;
    padding-left: 20px;
}
.input-width{
    width: 600px;
}
.p-padd{
    padding-bottom: 10px;
}
// element-ui 上传
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
    border: 1px dashed #CCC;
}
.avatar {
    width: 378px;
    // height: 178px;
    display: block;
}
.el-upload-padding {
    padding-bottom: 15px;
}
</style>